export default "__VITE_ASSET__CbmoPUlk__"